import React from 'react'
import PropTypes from 'prop-types'

import Print from '@hixme-ui/print'
import Title from '@hixme-ui/title'

import PageLayout from 'components/PageLayout'
import { PageTitle } from 'components/PageTitle'
import TermsAndConditionsCopy from 'components/TermsAndConditionsCopy'

import {
  ScrollDetectorContainer,
  SignOutContainer,
  TermsAndConditionsFormContainer,
  TermsAndConditionsHeaderContainer,
} from '../../containers'
import classes from './TermsAndConditionsView.scss'

const TermsAndConditionsView = ({ redirectTo }) => (
  <>
    <PageTitle title="Terms & Conditions" />
    <TermsAndConditionsHeaderContainer />
    <PageLayout
      title={
        <Title thin center>
          Terms &amp; Conditions
        </Title>
      }
      subtitle={
        <Title center smallest light thin>
          Before selecting your benefits, please review and agree to the Terms &amp; Conditions
          below. You may print it for later review.
        </Title>
      }
      breadcrumb={
        <div className={`${classes.toolbar} ${classes.hideOnPrint}`}>
          <SignOutContainer />
          <div className={classes.printAction}>
            <Print />
          </div>
        </div>
      }
      compactActions
      actions={
        <div className={`${classes.actionsWrap} ${classes.hideOnPrint}`}>
          <TermsAndConditionsFormContainer redirectTo={redirectTo} />
        </div>
      }
    >
      <ScrollDetectorContainer>
        <TermsAndConditionsCopy />
      </ScrollDetectorContainer>
    </PageLayout>
  </>
)

TermsAndConditionsView.displayName = 'TermsAndConditionsView'
TermsAndConditionsView.propTypes = {
  redirectTo: PropTypes.string,
}
TermsAndConditionsView.defaultProps = {
  redirectTo: undefined,
}

export default TermsAndConditionsView
